import { sectionTitle } from 'features/stepByStepProtocol/utils/protocol/sectionTitle';

const EMPTY_LIST = Object.freeze([]);

const noMatch = (definition) => ({
    caseMatched: false,
    formId: null,
    formTitle: null,
    sections: EMPTY_LIST,
    formFields: EMPTY_LIST,
    defaultGuidance: definition?.vehicleSwitch?.default ?? null,
});

/**
 * The protocol path for one value of the `vehicleSwitch` field (`vehicle.transportType`): the first
 * `<case>` that lists the exact value wins (AIQ keys, so case-sensitive). No match (no value, `/`, or
 * a type the protocol does not expect) returns the `<default>` guidance and no sections.
 *
 * Returns `{ caseMatched, formId, formTitle, sections, formFields, defaultGuidance }`; `formTitle`
 * falls back to the form id, each section is `{ id, type, title, intent, instructions }`.
 */
export function resolveProtocolPath(definition, value) {
    const normalizedValue = typeof value === 'string' ? value.trim() : '';
    const matchedCase = normalizedValue ? definition?.vehicleSwitch?.cases?.find(({ values }) => values.includes(normalizedValue)) : null;
    if (!matchedCase) return noMatch(definition);

    const form = matchedCase.formId ? definition.forms[matchedCase.formId] : null;
    const sections = matchedCase.stepRefs.map((stepRef) => {
        const step = definition.steps[stepRef];
        return { id: step.id, type: step.type, title: sectionTitle(step), intent: step.intent, instructions: step.instructions };
    });

    return {
        caseMatched: true,
        formId: form?.id ?? null,
        formTitle: form ? form.title || form.id : null,
        sections,
        formFields: form?.fields ?? EMPTY_LIST,
        defaultGuidance: null,
    };
}
